<template>
 <router-view></router-view>

</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'App',
  computed: {
    ...mapState('auth', ['currentUser'])
  },
  watch: {
    currentUser: {
      handler(newUser, oldUser) {
        // Ensure $gtm is available and enabled
        if (!this.$gtm || !this.$gtm.enabled()) {
          //console.warn('GTM: $gtm is not available or not enabled in App.vue watcher. GTM enabled state:', this.$gtm ? this.$gtm.enabled() : 'undefined');
          return;
        }

        // User logged in or changed
        if (newUser && newUser.uid) {
          // Check window.dataLayer directly. Ensure it's an array.
          let alreadyPushed = false;
          if (window.dataLayer && Array.isArray(window.dataLayer)) {
            alreadyPushed = window.dataLayer.some(item => item.user_id === newUser.uid && item.user_id !== undefined);
          }

          if (!oldUser || newUser.uid !== oldUser.uid || !alreadyPushed) {
            this.$gtm.push({ 'user_id': newUser.uid });
            //console.log('GTM: User ID set -', newUser.uid);
          }
        // User logged out
        } else if (!newUser && oldUser && oldUser.uid) {
            this.$gtm.push({ 'user_id': null }); // Clear user_id on logout
            //console.log('GTM: User ID cleared');
        // User object exists but no UID (could be an intermediate state or issue)
        } else if (newUser && !newUser.uid) {
          console.warn('GTM: currentUser is present but uid is missing. Pushing user_id: null. User object:', newUser);
          this.$gtm.push({ 'user_id': null });
          }
      },
      immediate: true // Important to catch initial state
    }
  }  
}
</script>